import Constants from 'expo-constants';

const AppEnv = {
  appSchemaPrefix: `${Constants.expoConfig.scheme}://`,
  associatedDomains: Constants.expoConfig.extra?.associatedDomains || [],
  appVersion: Constants.expoConfig.version,
};

export default AppEnv;
